/// <reference path="../_all.ts" />

module library {
  'use strict';

  export interface IUniqueFilter extends ng.IFilterService {
      (name: 'unique'): <T>(input : T[], key : string) => T[];
  }

  UniqueFilter.$inject = ['$parse'];
  export function UniqueFilter($parse : ng.IParseService) {

     return function<T>(input : T[], key : string) : T[] { 
       if (!input) return;
        var keyFunc = $parse(key);
        var unique = {};
        var uniqueList = [];
        for(var i = 0; i < input.length; i++){
            if(typeof unique[keyFunc(input[i])] == "undefined"){
                unique[keyFunc(input[i])] = "";
                uniqueList.push(input[i]);
            }
        }
        return uniqueList;
     }
  }
}